import styles from './index.module.scss';

const Loader = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      <title>Loading...</title>
      <g fill="#10dfc7">
        <g className={styles.animation}>
          <rect height="20" rx="2" width="20" x="25" y="3" data-color="color-2"></rect>
          <rect fill="#10dfc7" height="20" rx="2" width="20" x="25" y="25"></rect>
          <rect height="20" rx="2" width="20" x="3" y="25" data-color="color-2"></rect>
          <rect fill="#10dfc7" height="20" rx="2" width="20" x="3" y="3"></rect>
        </g>
      </g>
    </svg>
  );
};

export default Loader;
